import { Box, Typography, Tooltip, IconButton } from '@material-ui/core'
import { ExternalLink, Copy } from 'react-feather'
import { toast } from 'react-toastify'
import { makeStyles } from '@material-ui/styles'
import { useAuthStore } from '../stores/auth'
import colors from '../colors'
import { SPACING } from '../constants'
import {AuthState} from '../types/auth'
import useCurrentAppLocation from '../hooks/useCurrentAppLocation'
import OrgSwitcher from './OrgSwitcher'

const Header = () => {
  const styles = useStyles()
  const location = useCurrentAppLocation()
  const user = useAuthStore((state: AuthState) => state.user)
  const organizationName = useAuthStore((state: AuthState) => state.user && state.user.organization && state.user.organization.name)
  const vipLink = useAuthStore((state: AuthState) => state.user?.organization?.vipLink)

  const copyVipLink = () => {
    if (!vipLink) return
    navigator.clipboard.writeText(vipLink)
      .then(() => toast.success('Link copied'))
      .catch(() => toast.error('Could not copy the link'))
  }

  if (!user) { return null }
  return (
    <Box className={styles.container}>
      <Typography variant={'h3'}>
        {location.title}
      </Typography>
      <Box className={styles.right}>
        {/* The org's public page: what members see, and the link they share
            to get new ones. Wanted from any screen, so it lives up here. */}
        {vipLink && (
          <Box className={styles.vipLink}>
            <Tooltip title="Copy your member page link">
              <IconButton size="small" aria-label="Copy member page link" onClick={copyVipLink}>
                <Copy size={15} />
              </IconButton>
            </Tooltip>
            <Tooltip title={`Open ${vipLink}`}>
              <a href={vipLink} target="_blank" rel="noreferrer" className={styles.vipAnchor}>
                Member page <ExternalLink size={13} />
              </a>
            </Tooltip>
          </Box>
        )}
        {
          user.role === 'super_admin' ?
          <OrgSwitcher />
          : <Typography>
              {organizationName}
            </Typography>
        }
      </Box>
    </Box>
  )
}

const useStyles = makeStyles(() => ({
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACING * 2,
  },
  vipLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  vipAnchor: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    fontSize: 13,
    fontWeight: 600,
    color: colors.STITCH_BLUE,
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    background: colors.PALE_BLUE,
    color: colors.STITCH_BLACK,
    paddingTop: SPACING * 2,
    paddingBottom: SPACING * 2,
    paddingLeft: SPACING * 4,
    paddingRight: SPACING * 4,
    width: '100%',
    height: 60,
  },
}))

export default Header
